import { createSelector } from 'reselect';

// Config
import { getIsApplicationSelector } from '@redux/reducers/app/appSelector';
import { isStripeCheckoutEnabledFeatureActive } from '@redux/reducers/config/configSelector';
import {
  getConfirmedDeliveryAddressSelector,
  getSelectedDeliveryChoiceIdSelector,
} from '@redux/reducers/delivery/deliverySelector';
import { getSavedCardFormSubmitFailedSelector } from '@redux/reducers/form/formSelector';
import {
  getIsCardFormValidSelector,
  getSelectedPaymentTypeSelector,
  getSelectedSavedCardSelector,
} from '@redux/reducers/payment/paymentSelector';
import {
  getSavedPaymentCardsSelector,
  getSelectedBillingAddressAddressSelector,
} from '@redux/reducers/user/userSelector';

const payNowCategoryState = createSelector(
  [
    getConfirmedDeliveryAddressSelector,
    getSelectedDeliveryChoiceIdSelector,
    getIsCardFormValidSelector,
    getSelectedPaymentTypeSelector,
    getSelectedSavedCardSelector,
    getSavedPaymentCardsSelector,
    getSelectedBillingAddressAddressSelector,
    getSavedCardFormSubmitFailedSelector,
    getIsApplicationSelector,
    isStripeCheckoutEnabledFeatureActive,
  ],
  (
    confirmedDeliveryAddress,
    selectedDeliveryChoiceId,
    isCardFormValid,
    selectedPaymentType,
    selectedSavedCard,
    savedPaymentCards,
    selectedBillingAddress,
    savedCardFormSubmitFailed,
    isApplication,
    stripeCheckoutFlowEnabled,
  ) => ({
    confirmedDeliveryAddress: confirmedDeliveryAddress?.address,
    isCardFormValid,
    requestBillingAddressFromApplePay: !isApplication || stripeCheckoutFlowEnabled,
    savedCardFormSubmitFailed,
    savedPaymentCards,
    selectedBillingAddress,
    selectedDeliveryChoiceId,
    selectedPaymentType,
    selectedSavedCard,
    stripeCheckoutFlowEnabled,
  }),
);

export default payNowCategoryState;
